var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04aac8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ab6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#23c840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1eb639"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v3.809524h-16z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.3017668.95447561c-.18163533-.12163249-.40008346-.19257085-.63510013-.19257085-.63118257 0-1.14285715.51167458-1.14285715 1.14285714 0 .63118257.51167458 1.14285715 1.14285715 1.14285715.23501667 0 .4534648-.07093836.63510013-.19257085-.02104439.0013891-.04227558.00209466-.06367156.00209466-.52598548 0-.95238095-.42639548-.95238095-.95238096 0-.52598547.42639547-.95238095.95238095-.95238095.02139598 0 .04262717.00070556.06367156.00209466zm.88870939 2.09314344c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095238.38095238-.38095238s.38095238.17055819.38095238.38095238c0 .21039418-.17055819.38095238-.38095238.38095238zm1.52380952-1.52380953c-.21039418 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095239.1705582.38095239.38095238 0 .21039419-.1705582.38095238-.38095239.38095238zm1.52380953 0c-.21039419 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.1705582.38095238.38095238 0 .21039419-.1705582.38095238-.38095238.38095238zm0 1.52380953c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.17055819.38095238.38095238 0 .21039418-.1705582.38095238-.38095238.38095238zm-1.52380953 0c-.21039418 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.1705582-.38095238.38095238-.38095238.21039419 0 .38095239.17055819.38095239.38095238 0 .21039418-.1705582.38095238-.38095239.38095238z",
    mask: "url(#e)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/UZ.63de19c27d110cc6dab701ffc0ef9a6c.svg";
export { ForwardRef as ReactComponent };